
import { Box, Typography } from '@mui/material'

import ReportIcon from '@mui/icons-material/Report';

export const BoxProcesoNoEncontrado = ( ) => {

    return (
       <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={580}
        >
            <Box sx={{ maxWidth: 600, width: '90%', textAlign: 'center', p: 4, borderRadius: 4 }}>
               
                <Box sx={{ mb: 1 }} >
                    <ReportIcon sx={{ fontSize: 180 }} />
                </Box>

                <Box>

                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Proceso no encontrado
                    </Typography>
                  
                    <Typography variant="body2" color="text.secondary" fontSize={16} gutterBottom>
                        Es posible que la actividad haya sido cambiada, eliminada o no exista.
                    </Typography>                

                </Box>

            </Box>

        </Box>
    )
}